const NumberFormatList = {
  Sv: { lang: 'Sv', code: 'Sv-SE' },
  En: { lang: 'En', code: 'En-GB' },
};

const NumberFormatStyle = {
  Decimal: { style: 'decimal' },
  Currency: { style: 'currency', currency: 'SEK' },
  Percent: { style: 'percent' },
  None: { style: 'decimal', useGrouping: false },
};

export { NumberFormatList, NumberFormatStyle };
